import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './DropdownItem.scss';

/**
 * Reusable DropdownItem Stateless Component for Dropdown
 * @function DropdownItem
 * @param {Object} props
 * @return {ReactElement}
 */
const DropdownItem = props => {
  const {
    className,
    dangerBtn = false,
    disabled = false,
    onClick,
    selected = false,
    style,
    successBtn = false,
    text,
    title,
    value,
  } = props;

  return (
    <li
      className={classNames(
        styles.listItem,
        { [styles.listItemGreen]: successBtn },
        { [styles.listItemRed]: dangerBtn },
        { [styles.listItemDisabled]: disabled },
        className
      )}
      onClick={() => !disabled ? onClick(text, value) : null}
      style={style}
      title={title || text}
    >
      <div className={classNames(
        styles.itemContent,
        { [styles.itemContentDisabled]: disabled },
      )}>
        {text}
      </div>
      {/* TODO: Configure Checkmark Icon Logic */}
      {selected && <span>{/* checkmark icon */}</span>}
    </li>
  );
};

/**
  * @description DropdownItem propTypes
  * @prop {string} className
  * @prop {bool} dangerBtn - sets red text state
  * @prop {bool} disabled - item is disabled or not
  * @prop {Function} onClick - clickHandler callback
  * @prop {boolean} selected -- flag to display selected checkmark
  * @prop {Object} style -- style object
  * @prop {string} successBtn - sets green text state
  * @prop {string} text -- item text
*/
DropdownItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
  dangerBtn: PropTypes.bool,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
  successBtn: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.object,
    PropTypes.string,
  ])
};

export default DropdownItem;
